module.exports = __webpack_public_path__ + "img/pensees4_md.c28f59dd.jpg";